// StepCard

export const STEP_CARD_TEST_IDS = {
  TITLE: 'step-card-title-test-id',
  TEXT: 'step-card-text-test-id',
};

export const STEP_ACTION_BUTTON_TEST_IDS = {
  CONTINUE: 'step-action-button-continue-test-id',
  VIEW: 'step-action-button-view-test-id',
  VIEW_EDIT: 'step-action-button-view-edit-test-id',
  UNAVAILABLE: 'step-action-button-unavailable-test-id',
};

export const STEP_COMPLETION_STATUS_TEST_IDS = {
  COMPLETED: 'step-completion-status-completed-test-id',
  READY_TO_BEGIN: 'step-completion-status-ready-to-begin-test-id',
  IN_PROGRESS: 'step-completion-status-in-progress-test-id',
  CANNOT_COMPLETE_YET: 'step-completion-status-cannot-complete-yet-test-id',
};
